import React from 'react';
import PageNotFoundSVG from "../../assets/images/page_not_found.svg";
import { BsArrowLeft } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import Max_Logo from "../../assets/images/fbslogoinverse.svg";

const NotFound: React.FC = () => {
  
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className='fixed bg-primary-light text-center  p-3 w-screen top-0 flex justify-center'>
      <img
              src={Max_Logo}
              alt="sidebar-logo"
              className=""
            />
      </div>
      <div className="flex flex-col items-center justify-center text-center min-h-screen">
        <img src={PageNotFoundSVG} alt="Page Not Found" className="" />
        <div className='text-primary-light font-medium mt-5 text-3xl'>
          Oops! We Couldn’t Find That Page
        </div>
        <div className='font-normal mt-2 text-lg font-helveticaNeue text-[#848888]'>
           It looks like this page is missing or no longer available. <br/> 
           No worries! Let’s get you back on track.
        </div>
        <Link
          to="/"
          className="flex items-center justify-center text-[#17BE62] bg-secondary-light mt-4 rounded-lg py-3 px-5 text-white font-medium hover:bg-primary-light"
        >
          <BsArrowLeft className="mr-2 w-[1.5rem] h-[1.5rem]" /> Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
